export default "__VITE_ASSET__CdS5A7Nm__"